import angular from 'angular';
import { getYesNoText } from 'Common/utilities/onboarding';

const yesNoValue = () => getYesNoText;
export const loadModule = () =>
  angular.module('app').filter('yesNoValue', yesNoValue);
